// extracted by mini-css-extract-plugin
export default {"wrapper":"OU-z","ratingContainer":"PU-z","ratingValue":"QU-z","starSprite":"RU-z","ratingLabel":"SU-z","error":"TU-z","errorBox":"UU-z"};